__turbopack_context__.v({
  "active": "sgv3nW_active",
  "closed": "sgv3nW_closed",
  "homepageMenuItem": "sgv3nW_homepageMenuItem",
  "iconWrapper": "sgv3nW_iconWrapper",
  "open": "sgv3nW_open",
  "sidebarMenuItem": "sgv3nW_sidebarMenuItem",
  "styledLink": "sgv3nW_styledLink",
  "title": "sgv3nW_title",
});
